// Quiz upsell ATC Functionality
if (!customElements.get('quiz-upsell-items')) {
  class QuizUpsellItems extends HTMLElement {

    constructor() {
      super();

      this.upsellVersion = this.dataset.upsellVersion;
      this.upsell = this.dataset.upsell;
      this.upsellFreeAc = this.dataset.upsellFreeAc;
      this.upsellFreeCs = this.dataset.upsellFreeCs;
      this.brush = this.dataset.brush;
      this.zipCode = this.dataset.zipCode;
      this.selectedShade = this.dataset.selectedShade;
      this.subscriptionId = this.dataset.subscriptionId;

      this.atcButton = this.querySelector('[data-quiz-upsell-atc]');

      document.querySelectorAll('[data-quiz-upsell-atc]').forEach(button => {
        if (button !== this.atcButton) {
          button.innerHTML = this.atcButton.innerHTML;
        }
      });

      this.fetchConfig = fetchConfig('javascript');
      this.fetchConfig.headers['X-Requested-With'] = 'XMLHttpRequest';

      this.handleClickBind = this.handleClick.bind(this);
    }

    connectedCallback() {
      window.addEventListener('click', this.handleClickBind);
    }

    handleClick(evt) {
      const upsellATCButton = evt.target.closest('[data-quiz-upsell-atc]');
      const regularATCButton = evt.target.closest('[data-quiz-regular-atc]');
      if (upsellATCButton) {
        this.upsellATC(true);
      } else if (regularATCButton) {
        this.upsellATC(false);
      }
    }

    // Method for Criteo tracking, which returns a Promise
    criteoTracking(itemArray, data) {
      return new Promise((resolve, reject) => {
        try {
          // Retrieve email from localStorage
          const quizUserEmail = localStorage.getItem("quizUserEmail") || "";
          //console.log('Item added to cart:', data); // Log the added item data

          window.criteo_q = window.criteo_q || [];
          const deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";

          // Prepare the items array for Criteo, mapping over itemArray to get variants
          const itemsToTrack = itemArray.map((item, index) => {
            return {
              id: item.id,  // Variant ID, not product ID
              price: Shopify.formatMoney(data.items[index].final_price),  // Access the final_price from data.items -  final price is caculated after all discounts
              quantity: item.quantity  // Quantity of the variant being added
            };
          });

          window.criteo_q.push(
            { event: "setAccount", account: 84368 },
            { event: "setEmail", email: quizUserEmail, hash_method: "sha256" },
            { event: "setEmail", email: quizUserEmail, hash_method: "md5" },
            { event: "setSiteType", type: deviceType },
            { event: "setZipcode", zipcode: this.zipCode },
            { event: "addToCart", item: itemsToTrack }
          );

          // Resolve promise after the tag is fired
          resolve("Criteo Tag Fired Successfully");
        } catch (error) {
          console.error("Error in Criteo Tag:", error);
          reject(error);  // Reject the promise in case of any error
        }
      });
    }


    upsellATC(upgradeOrder) {
      const itemArray = [];


      if (this.selectedShade && this.selectedShade !== '') {
        itemArray.push({
          quantity: 1,
          id: this.selectedShade,
          selling_plan: this.subscriptionId,
        });
      }

      if (this.brush && this.brush !== '') {
        itemArray.push({
          quantity: 1,
          id: this.brush
        });
      }

      if (upgradeOrder) {

        if (this.upsell && this.upsell !== '') {
          const upsellItem = {
            quantity: 1,
            id: this.upsell,
          };
          
          itemArray.push(upsellItem);
        }

        if (this.upsellFreeAc && this.upsellFreeAc !== '') {
          const upsellItem = {
            quantity: 1,
            id: this.upsellFreeAc,
          };
  
          if (this.upsellVersion === 'ec-sub') {
            upsellItem.properties = {
              _quiz_upsell_components_ec2: `${this.upsell},${this.selectedShade}`
            }
          }
          
          itemArray.push(upsellItem);
        }



        if (this.upsellFreeCs && this.upsellFreeCs !== '') {
          const upsellItem = {
            quantity: 1,
            id: this.upsellFreeCs,
          };
  
          if (this.upsellVersion === 'ec-sub') {
            upsellItem.properties = {
              _quiz_upsell_components_ec2: `${this.upsell},${this.selectedShade},${this.upsellFreeCs}`
            }
          }
          
          itemArray.push(upsellItem);
        }

        
      }

      if (itemArray.length > 0) {
        this.atc(itemArray, upgradeOrder);
      }
    }

    atc(itemArray, upgradeOrder) {
      document.body.classList.add('hide-upcart');
      this.fetchConfig.body = JSON.stringify({ 'items': itemArray });

      fetch(routes.cart_add_url, this.fetchConfig)
        .then((response) => {
          if (response.ok) {
            return response.json(); // Parse the response JSON
          } else {
            throw new Error('Failed to add item to cart');
          }
        })
        .then((data) => {
          // Call criteoTracking and wait for it to resolve before redirecting
          this.criteoTracking(itemArray, data)
            .then(() => {
              const addCartAttribute = this.addCartAttribute(upgradeOrder)
              console.log(addCartAttribute)
              addCartAttribute.then(() => {
                window.location.href = '/checkout';  // Redirect after Criteo tracking
              });
            })
            .catch((error) => {
              const addCartAttribute = this.addCartAttribute(upgradeOrder)
              console.log(addCartAttribute)
              addCartAttribute.then(() => {
                console.error("Criteo Tracking failed, proceeding to checkout:", error);
                window.location.href = '/checkout';  // Redirect even if Criteo tracking fails
              });
            });
        })
        .catch((error) => {
          console.error('Error:', error);
          document.body.classList.remove('hide-upcart');
        });
    }


    addCartAttribute(upgradeOrder) {
      const attributeFetch = fetch(routes.cart_update_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          attributes: {
            '_cc_quiz_atc': upgradeOrder ? 'CCQUIZECUPSELL' : 'CCQUIZNOUPSELL'
          }
        }),
      })
      .then(res => res.json())
      .catch(err => console.error(err));
      
      return attributeFetch;
    }
  }
  customElements.define('quiz-upsell-items', QuizUpsellItems);
}
